import {
  COMPETERA_EXPERIMENT,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const experimentCompeteraIsEnabled = (experiments?: Experiment[]) => {
  const experimentCompetera = getExperiment(COMPETERA_EXPERIMENT, experiments)
  return experimentCompetera?.isEnabled
}

export const experimentCompeteraIsEnabledAndV1 = (
  experiments?: Experiment[]
) => {
  const experimentCompetera = getExperiment(COMPETERA_EXPERIMENT, experiments)
  return (
    experimentCompetera?.isEnabled &&
    experimentCompetera?.variant === EXPERIMENT_VARIATION.V1
  )
}
